import { buildURLSearchParams } from '../helpers/format';
import onApiRequest from './ApiRequestHandler';

const onPaginatedApiRequest = async (
  { dispatch, stateName, url, params, skipSuccessStateUpdate = false },
  onSuccessCallback = null,
  onErrorCallback = null
) => {
  const searchParams = params ? buildURLSearchParams(params) : null;

  if (dispatch && stateName) {
    dispatch({
      type: 'fetching',
      stateName,
      payload: { value: [], filter: params }
    });
  }

  let finalData = [];
  const paginateFetch = (page = 1) => {
    searchParams.set('page', page);

    onApiRequest(
      {
        url: `${url}?${searchParams.toString()}`,
        type: 'get'
      },
      (d) => {
        finalData = [...finalData, ...d.data];
        if (!skipSuccessStateUpdate && dispatch && stateName) {
          dispatch({
            type: d.pageIndex && d.pageIndex > 1 ? 'append' : 'success',
            stateName,
            payload: { value: [...d.data], loading: d.pageIndex < d.totalPages }
          });
        }

        if (d.pageIndex < d.totalPages) {
          paginateFetch(d.pageIndex + 1);
          return;
        }

        if (onSuccessCallback) {
          onSuccessCallback(finalData);
        }
      },
      onErrorCallback
    );
  };

  paginateFetch(1);
};

export default onPaginatedApiRequest;
